import type { HookFormSubmitHandler, SelectItem } from 'common/models';
import {
  DateInput,
  FormError,
  FormWrapper,
  SelectInput,
  SubmitButton,
  TextAreaInput
} from 'components/forms/hook-form';
import dayjs from 'dayjs';
import { useCustomTranslation } from 'helpers/translationHelper';
import { useValidators } from 'helpers/validation';

import type { PublicOrderData } from '../models';

interface Props {
  contactPeople: SelectItem[];
  onSubmit: HookFormSubmitHandler<PublicOrderFormValues>;
  order?: PublicOrderData;
}

export interface PublicOrderFormValues {
  requestedDate: string;
  problemDescriptionFromCustomer?: string | null;
  contactPersonId?: string | null;
}

const PublicOrderForm = ({ contactPeople, onSubmit, order }: Props) => {
  const { t } = useCustomTranslation();
  const validators = useValidators();

  const defaultValues: PublicOrderFormValues = {
    requestedDate: order?.requestedDate || '',
    contactPersonId: order?.contactPersonId || '',
    problemDescriptionFromCustomer: order?.problemDescriptionFromCustomer || ''
  };

  return (
    <FormWrapper<PublicOrderFormValues> defaultValues={defaultValues} onSubmit={onSubmit}>
      <DateInput
        name="requestedDate"
        label={t('publicOrder.forms.requestedDateLabel')}
        inputNote={{
          mode: 'tooltip',
          value: t('orderRequests.forms.requestedDateExplain')
        }}
        required
        options={{ required: validators.required }}
        disabledDate={(current: dayjs.Dayjs) => current && current < dayjs.utc().endOf('day')}
      />
      <SelectInput
        label={t('publicOrder.forms.contactPersonLabel')}
        name="contactPersonId"
        items={contactPeople}
      />
      <TextAreaInput
        label={t('publicOrder.forms.problemDescriptionFromCustomerLabel')}
        name="problemDescriptionFromCustomer"
      />
      <FormError />
      <SubmitButton
        label={t('orderRequests.forms.sendRequestButton')}
        className="public-btn"
        ignoreDirtyCheck
      />
    </FormWrapper>
  );
};

export default PublicOrderForm;
